import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/ramana-steel-logo1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/updatedteam1.jpeg';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import ContactMain from './ContactMain';
import SEOHelmet from '../../components/SEO/SEOHelmet';

// Breadcrumbs Background Image

const Contact = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
            <SEOHelmet 
                title="Contact Ramana Steels | Get in Touch"
                description="Contact Ramana Steels for inquiries about scrap processing equipment, pricing, and support. Fast response guaranteed."
                keywords="contact ramana steels, support, inquiry, scrap equipment, get in touch"
                canonicalUrl="https://ramanasteels.com/contact"
            />
            <Header
                navImg={navImg1}
                parentMenu='contact'
                activeMenu="/contact"
            />
            {/* SiteBreadcrumb */}
            <SiteBreadcrumb
                pageTitle="Contact"
                pageName="Contact"
                breadcrumbsImg={bannerbg}
            />
            {/* SiteBreadcrumb */}
            <ContactMain />
            {/*cta-section */}
            {/* <CtaTwo /> */}
            {/*cta-section end */}
            <BackToTop scroll={isVisible} />
            <FooterTwo />
        </React.Fragment>
    );
}

export default Contact;